import React, { useEffect, useState } from 'react';
import { Link, Box,} from '@mui/material';

export const footerLinks = [
  
    <Box mt={2} display="flex" justifyContent="center">
    <Link href="https://cents2.com.au/terms" variant="body2" sx={{ mr: 3}}>
      Terms
    </Link>
    <Link href="https://cents2.com.au/privacy" variant="body2" >
      Privacy
    </Link>
    <Link href=" https://cents2.com.au/contact" variant="body2" sx={{ ml: 3}}>
      Help
    </Link>
  </Box>
];
